import React from 'react';
import { Input } from 'antd';
const { TextArea } = Input;
import { BasicText } from '@components';
import './inputs.css';

const LongInput = (props) => {
  return (
    <div className="short-input-container">
      {props.inputHeader && <BasicText fontSize="12px">{props.inputHeader}</BasicText>}
      <TextArea
        placeholder={props.placeholder}
        autoSize={{ minRows: 5, maxRows: 8 }}
        onChange={(e) => props.onChange(e.target.value)}
        value={props.value}
        style={{ fontSize: "14px", minWidth: "100%" }}
      />
    </div>
  )
}

export default LongInput;
